export default __webpack_public_path__ + "static/media/careers-cult.fbd2a19a.webp";